<template>
  <pf-nav-group v-bind="ouiaProps" v-show="visible" :title="title">
    <slot  />
  </pf-nav-group>
</template>

<script  lang="ts">
export const GrantedLinkKey: ChildrenTrackerInjectionKey<InstanceType<typeof GrantedLink>> = Symbol("GrantedLinkKey");
</script>

<script lang="ts" setup>
import { ref, computed, toValue } from 'vue';
import { provideChildrenTracker, type ChildrenTrackerInjectionKey } from '@common/use';
// import ChevronRightIcon from '@vue-patternfly/icons/chevron-right-icon';
// import ChevronDownIcon from '@vue-patternfly/icons/chevron-down-icon';
import type GrantedLink from './granted-link.vue';
import { invoke, until } from '@vueuse/core';
import { useOUIAProps, type OUIAProps } from '@/common/ouia';

export interface Props extends OUIAProps {
  title: string
};

const menuItems = provideChildrenTracker(GrantedLinkKey);
const visible = computed(() => menuItems.value.some(i => toValue(i.$.exposed?.visible)));
const active = computed(() => menuItems.value.some(i => toValue(i.$.exposed?.active)));

invoke(async() => {
  await until(active).toBeTruthy();
  showSubmenu.value = true;
});

const props = defineProps<Props>();
const ouiaProps = useOUIAProps(props);

const showSubmenu = ref(false);
</script>
